import axios from "axios";

// Ensure BASE_URL is correctly retrieved from environment variables
const BASE_URL = process.env.REACT_APP_BASE_URL;

/**
 * Submits the contact form data to the server.
 *
 * @param {Object} formData - The contact form data.
 * @param {string} formData.first_name - The first name.
 * @param {string} formData.last_name - The last name.
 * @param {string} formData.email - The email address.
 * @param {string} formData.phone_number - The phone number.
 * @param {string} formData.purpose - The purpose of the inquiry.
 * @param {string} formData.message - The message.
 *
 * @returns {Object} The response data from the API.
 *
 * @throws Will throw an error if the API call fails.
 */
export const submitContactForm = async (formData) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/contact`,
      {
        first_name: formData.first_name,
        last_name: formData.last_name,
        email: formData.email,
        phone_number: formData.phone_number,
        purpose: formData.purpose,
        message: formData.message,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error submitting contact form:", error);
    throw error;
  }
};
